<p-toolbar>
  <div class="p-toolbar-group-start">
    <app-header-text-icon />
  </div>
</p-toolbar>
